var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolShareHover = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27598 7.77867C5.79713 6.82283 4.80853 6.16667 3.66667 6.16667C2.05584 6.16667 0.75 7.4725 0.75 9.08333C0.75 10.6942 2.05584 12 3.66667 12C4.80853 12 5.79713 11.3438 6.27598 10.388M6.27598 7.77867C6.47265 8.17124 6.58333 8.61436 6.58333 9.08333C6.58333 9.5523 6.47265 9.99542 6.27598 10.388M6.27598 7.77867L11.8907 4.97132M6.27598 10.388L11.8907 13.1953M11.8907 4.97132C12.3695 5.92716 13.3581 6.58333 14.5 6.58333C16.1108 6.58333 17.4167 5.2775 17.4167 3.66667C17.4167 2.05584 16.1108 0.75 14.5 0.75C12.8892 0.75 11.5833 2.05584 11.5833 3.66667C11.5833 4.13564 11.694 4.57875 11.8907 4.97132ZM11.8907 13.1953C11.694 13.5879 11.5833 14.031 11.5833 14.5C11.5833 16.1108 12.8892 17.4167 14.5 17.4167C16.1108 17.4167 17.4167 16.1108 17.4167 14.5C17.4167 12.8892 16.1108 11.5833 14.5 11.5833C13.3581 11.5833 12.3695 12.2395 11.8907 13.1953Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolShareHover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_share_hover.d1150bc510471775728fa5ee275c9a67.svg";